// TODO: replace with retryAxios after in https://leaseplandigital.atlassian.net/browse/NGRE2E-3331
import { useMemo } from 'react'
import useSWR from 'swr'

import { useAppConfig } from '../../AppConfigContext/AppConfigContext'

import type {
  AppLocale,
  SCBrand,
  TContent,
  TContentMap,
} from '@ngb-frontend/shared/types'

export const useFetchContent = (
  brand: SCBrand,
  contentLocales: AppLocale[],
  fallback: TContent,
) => {
  const config = useAppConfig()

  const { data } = useSWR<TContentMap>(
    [config.apiRoutes.content, { brand, contentLocales }],
    { revalidateOnMount: true },
  )

  const contentMap = useMemo(() => {
    if (!data) {
      return undefined
    }

    return Object.keys(data).reduce<TContentMap>(
      (acc, locale) => {
        const localeKey = locale as AppLocale

        if (data[localeKey]) {
          return acc
        }

        return { ...acc, [localeKey]: fallback }
      },
      { ...data },
    )
  }, [data, fallback])

  return { contentMap, isContentReady: Boolean(contentMap) }
}
